import React from "react";
import { RotateCcw, RotateCw, LocateFixed } from "lucide-react";
import { roundBtn } from "../kota/ui";

// Dock kamera Alun-alun (kanan, di bawah bar atas): putar kiri / putar kanan 90° (tampilan tetap isometrik belah ketupat) dan kembali mengikuti karakter sendiri.
// Puntir dua jari di kanvas juga memutar kamera; tombol ini untuk yang lebih suka ketuk.
export function KameraDock({ onPutar, onPusat, bisaPusat }) {
  const btn = { ...roundBtn(false), width: 38, height: 38, pointerEvents: "auto" };
  return (
    <div data-testid="alun-kamera-dock" style={{ position: "absolute", right: 12, top: "50%", transform: "translateY(-50%)", display: "flex", flexDirection: "column", gap: 8, pointerEvents: "none", zIndex: 5 }}>
      <button data-testid="alun-putar-kiri" aria-label="Putar kamera ke kiri" title="Putar kamera" onClick={() => onPutar(-Math.PI / 2)} style={btn}><RotateCcw size={17} strokeWidth={2} /></button>
      <button data-testid="alun-putar-kanan" aria-label="Putar kamera ke kanan" title="Putar kamera" onClick={() => onPutar(Math.PI / 2)} style={btn}><RotateCw size={17} strokeWidth={2} /></button>
      {bisaPusat && <button data-testid="alun-pusat" aria-label="Kembali ke karakterku" title="Kembali ke karakterku" onClick={onPusat} style={btn}><LocateFixed size={17} strokeWidth={2} /></button>}
    </div>
  );
}
